import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"

import { IBOLIssuingContract } from "~/features/contracts/model/types"
import { RootState } from "~/store/store"
import { IBOL } from "~/types/bol"

export interface ISelectedCargoOwnerContract extends IBOL {}
export interface ISelectedBOLIssuingCompanyContract
  extends IBOLIssuingContract {}

export interface ContractState {
  selectedCargoOwnerContract?: ISelectedCargoOwnerContract
  selectedBOLIssuingCompanyContract?: ISelectedBOLIssuingCompanyContract
}

export const initialBOLState: ContractState = {}

export const ContractManagementSlice = createSlice({
  name: "contract-management",
  initialState: initialBOLState,
  reducers: {
    setSelectedBOLIssuingCompanyContract: (
      state,
      action: PayloadAction<IBOLIssuingContract>,
    ) => {
      state.selectedBOLIssuingCompanyContract = {
        ...action.payload,
      }
    },
    setSelectedCargoOwnerContract: (state, action: PayloadAction<IBOL>) => {
      state.selectedCargoOwnerContract = {
        ...action.payload,
      }
    },
  },
})

export const useContractManagement = (): ContractState =>
  useSelector((state: RootState) => state.contractManagement)

export const {
  setSelectedBOLIssuingCompanyContract,
  setSelectedCargoOwnerContract,
} = ContractManagementSlice.actions

export default ContractManagementSlice.reducer
